export function removeUndefinedFields<T>(obj: T): Partial<T> {
  if (!obj || typeof obj !== 'object') {
    return obj;
  }

  return Object.entries(obj).reduce((acc, [key, value]) => {
    // Handle nested objects
    if (value && typeof value === 'object') {
      const cleaned = removeUndefinedFields(value);
      if (Object.keys(cleaned).length > 0) {
        acc[key] = cleaned;
      }
      return acc;
    }

    // Skip undefined values
    if (value !== undefined) {
      acc[key] = value;
    }
    return acc;
  }, {} as any);
}